import React from 'react'
import Navbar from '../inc/Navbar'
import Room from './Room'
import ScrollToTop from "react-scroll-to-top";
function Roompage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        
        <br/>
        <ScrollToTop Smooth top="100" color="#48340A"/>
      <div className='sadarkrishnagar'>
        <br/>
        <Room/>
          <br/>
        </div>
      
    </div>
  )
}

export default Roompage